module.exports = __webpack_public_path__ + "05fb7a9645f681e39a771700a1e11801.svg";